import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'

interface BackLinkProps {
  href: string
  label: string
  className?: string
}

/** Editorial "back to …" link that sits atop detail pages. */
export function BackLink({ href, label, className }: BackLinkProps) {
  return (
    <Link
      href={href}
      className={`inline-flex items-center gap-1.5 text-[13px] font-semibold text-text-muted hover:text-text-primary transition-colors ${className ?? ''}`}
    >
      <ArrowLeft className="w-4 h-4" aria-hidden />
      {label}
    </Link>
  )
}
